import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { usePortfolioStore } from '../../store'
import Footer from './Footer'
import Header from './Header'
import SidePanel from './SidePanel'

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation()
  const { setCurrentPage, setSidePanelVisible, accessibilityControls } =
    usePortfolioStore()

  // Update current page when route changes
  useEffect(() => {
    setCurrentPage(location.pathname)
  }, [location.pathname, setCurrentPage])

  // Close side panel when route changes
  useEffect(() => {
    setSidePanelVisible(false)
  }, [location.pathname, setSidePanelVisible])

  // Apply accessibility controls to document
  useEffect(() => {
    const root = document.documentElement

    // Apply reduced motion preference
    if (accessibilityControls.reducedMotion) {
      root.style.setProperty('--motion-scale', '0')
    } else {
      root.style.removeProperty('--motion-scale')
    }

    // Apply high contrast mode
    if (accessibilityControls.highContrast) {
      root.classList.add('high-contrast')
    } else {
      root.classList.remove('high-contrast')
    }

    // Apply large text mode
    if (accessibilityControls.largeText) {
      root.classList.add('large-text')
    } else {
      root.classList.remove('large-text')
    }
  }, [accessibilityControls])

  return (
    <>
      <div className="app-layout">
        <Header />

        <main className="main-content">{children}</main>

        <Footer />
      </div>

      {/* Side panel rendered outside of app-layout to ensure true fixed positioning */}
      <SidePanel />
    </>
  )
}

export default Layout
